import { createDarkFamilyComponents } from '../dark-family/create-components'

export const createComponents = ({ palette }) => {
    return createDarkFamilyComponents({
        palette,
        tweaks: {
            appBarAlpha: 0.94,
            paperAlpha: 0.97,
            elevatedSurfaceAlpha: 0.96,
            tableHeadAlpha: 0.05,
            borderAlpha: 0.1
        }
    })
}
